import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ColorInjector } from '../ColorInjector';
import { AuthHandler } from '@usimweb/core-auth';

@Component({
    selector: 'usimweb-request-bar',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './request-bar.component.html',
    styleUrls: ['./request-bar.component.scss'],
    standalone: false
})
export class RequestBarComponent extends ColorInjector implements OnChanges {
  @Input() cardItem: any;

  public barColor: string = '#5177B5';

  public isShared: boolean = true;
  public supportInfo: string = '';

  ngOnChanges(changes: SimpleChanges): void {
    if (this.cardItem && changes['cardItem']) {
      if (this.cardItem.created_by.toLowerCase() === AuthHandler.basfUserName.toLowerCase()) {
        this.isShared = false;
        this.barColor = this.mainColor;
      }

      if (this.cardItem.support_requests_info) {
        const support_requests_info = this.cardItem.support_requests_info;

        const inProgress = support_requests_info.filter((request: any) => request.status == 'in_progress');
        if (inProgress.length > 0) {
          this.supportInfo = 'Support in progress';
          return;
        }

        const newRequest = support_requests_info.filter((request: any) => request.status == 'new_request');
        if (newRequest.length > 0) {
          this.supportInfo = 'Support requested';
          return;
        }
      }
    }
  }
}
